import React from 'react';
import { Button, Form, Input, Typography, Card } from 'antd';
import { PlayCircleOutlined, CodeOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const ComandoPersonalizado = ({ form, onFinish, customComando }) => {
  return (
    <div>
      <Title level={5} style={{ marginBottom: 16, color: '#595959' }}>
        Comando personalizado
      </Title>
      <Card
        style={{
          borderRadius: 12,
          border: '1.5px solid #d9d9d9',
        }}
        bodyStyle={{ padding: '24px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <CodeOutlined style={{ fontSize: 32, color: '#13c2c2', marginBottom: 8, display: 'block' }} />
          <Text type="secondary" style={{ fontSize: 13 }}>
            Ejecuta cualquier comando Artisan directamente desde el panel
          </Text>
        </div>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="comando"
            rules={[
              { required: true, message: 'Ingrese un comando' },
              {
                validator: (_, value) =>
                  value && value.trim() !== ''
                    ? Promise.resolve()
                    : Promise.reject(new Error('El comando no puede estar vacío')),
              },
            ]}
            style={{ marginBottom: 16 }}
          >
            <Input
              size="large"
              placeholder="Ej: app:comandoEjemplo --propiedad"
              style={{ borderRadius: 8, fontFamily: 'monospace' }}
              prefix={<CodeOutlined style={{ color: '#bfbfbf' }} />}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={customComando.isLoading}
              icon={<PlayCircleOutlined />}
              size="large"
              style={{
                borderRadius: 25,
                paddingLeft: 28,
                paddingRight: 28,
                height: 44,
              }}
            >
              Ejecutar comando
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ComandoPersonalizado;
